/* @flow */
import Button from 'components/Button.jsx';
import Chat from 'entities/Chat';
import ChatActions from 'chat/actions/ChatActions';
import DisableRepliesConfirmationDialog from 'chat/components/DisableRepliesConfirmationDialog.jsx';
import Glyph from 'components/Glyph.jsx';
import ModalTrigger from 'components/ModalTrigger.jsx';
import React from 'react';

class ManageChatButton extends React.Component {
  static propTypes = {
    chat: React.PropTypes.instanceOf(Chat).isRequired,
    buttonClassName: React.PropTypes.string,
  };

  renderDisabledRepliesButton() {
    const { chat } = this.props;

    // FIXME: Remove spans required for React 15 upgrade
    return (
      <ModalTrigger modal={<DisableRepliesConfirmationDialog chat={chat} />}>
        <Button
          level="text"
          weight="semibold"
          className={this.props.buttonClassName}>
          <Glyph name="chat-close-bubble-fill" size="large" />
          <span>
            Turn off replies
          </span>
        </Button>
      </ModalTrigger>
    );
  }

  renderEnabledRepliesButton() {
    const { chat } = this.props;

    const buttonProps = {};
    if (chat.canOpen()) {
      buttonProps.onClick = () => ChatActions.enableReplies(chat);
    } else {
      buttonProps.disabled = true;
      // If can_send is false, we assume this thread has an under13 user.
      if (!chat.canSend()) {
        Object.assign(buttonProps, {
          // There is a bug in Chrome where disabled form elements don't properly fire mouseleave
          // events. This was breaking tooltip behavior. To fix, just make the button a link.
          href: '#',
          tooltip: 'Two-way messaging is not permitted with students under the age of 13.',
          tooltipPlacement: 'bottom',
        });
      }
    }

    // FIXME: Remove spans required for React 15 upgrade
    return (
      <Button
        className={this.props.buttonClassName}
        level="text"
        weight="semibold"
        {...buttonProps}>
        <Glyph name="chat-check-bubble-fill" size="large" />
        <span>
          Turn on replies
        </span>
      </Button>
    );
  }

  renderManagedButton() {
    const { chat } = this.props;

    // The chat be open with can_send false (for under 13 users)
    if (chat.isOpen() && chat.canSend()) {
      return this.renderDisabledRepliesButton();
    } else {
      return this.renderEnabledRepliesButton();
    }
  }

  render() {
    const { chat } = this.props;

    if (!chat.canManageReplies()) {
      return null;
    }

    return (
      <div className="ManageChatButton">
        {this.renderManagedButton()}
      </div>
    );
  }
}

export default ManageChatButton;



// WEBPACK FOOTER //
// ./src/chat/components/ManageChatButton.jsx